module.exports = __webpack_public_path__ + "img/six2.42af477b.jpg";